export default __webpack_public_path__ + "static/media/ChristianSneaker.52a3ceeb.jpg";